import React from "react";
import { Box, Heading, Text } from "@chakra-ui/react";

function NotFound(): React.JSX.Element {
  return (
    <Box
      textAlign="center"
      py={{ base: 10, md: 20 }}
      px={{ base: 6, md: 10 }}
      bgGradient="linear(to-r, green.200, green.500)"
      minH="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Heading
        as="h1"
        fontSize={{ base: "6xl", md: "9xl" }}
        bgGradient="linear(to-r, green.600, green.800)"
        backgroundClip="text"
      >
        404
      </Heading>
      <Text fontSize={{ base: "xl", md: "2xl" }} mt={3} mb={2} color="green.800">
        페이지를 찾을 수 없습니다
      </Text>
      <Text color="green.700" mb={6}>
        요청하신 페이지가 존재하지 않거나,<br /> 다른 페이지로 이동되었을 수 있습니다.
      </Text>
    </Box>
  );
}

export default NotFound;